import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function GoogleCallback() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [err, setErr] = useState("");
  const ran = useRef(false);
  const { user } = useAuth();
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (sp.get("error")) { setErr(`Google sign-in was cancelled (${sp.get("error")})`); return; }
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    api.post("/api/seo/google/exchange", { code: sp.get("code"), state: sp.get("state"), redirect_uri: `${window.location.origin}/admin/seo/google-callback` })
      .then(({ data }) => nav(user?.role === "admin" ? `/admin/seo?tab=setup&site=${data.site}` : "/client/seo", { replace: true })).catch(e => setErr(errMsg(e)));
  }, [sp, nav, user]);
  return (
    <div className="min-h-screen flex items-center justify-center pt-20" data-testid="google-callback">
      {err ? <div className="text-center space-y-3"><p className="text-red-600 font-semibold" data-testid="google-callback-error">{err}</p><button onClick={() => nav(user?.role === "admin" ? "/admin/seo?tab=setup" : "/client/seo")} className="h-10 px-5 rounded-full bg-slate-900 text-white text-sm font-bold">Back to SEO dashboard</button></div>
        : <p className="flex items-center gap-2 text-slate-600"><Loader2 className="w-5 h-5 animate-spin" />Connecting Google…</p>}
    </div>
  );
}
